<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.agentId" placeholder="承办单位" @change="getOfficeList" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in agentList" :key="index" :label="item.agentName" :value="item.agentId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.officeId" placeholder="考级点" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in officeList" :key="index" :label="item.officeName" :value="item.officeId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.auditStatus" placeholder="审核状态" filterable clearable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.auditStatus)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="考生姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam)),getPage({pageNum: 1}),getSpecialtyList(), officeList = [], officeId = ''" type="default">重置</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column prop="admissionTicketNo" label="准考证号"></el-table-column>
        <el-table-column prop="examineeName" label="姓名"></el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号码"></el-table-column>
        <el-table-column prop="categoryName" label="所属分类"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业">
          <template slot-scope="scope">
            {{scope.row.specialtyName}}-{{scope.row.gradeName}}
          </template>
        </el-table-column>
        <el-table-column prop="oldAgentName" label="原承办单位"></el-table-column>
        <el-table-column prop="oldOfficeName" label="原考级点"></el-table-column>
        <el-table-column prop="newAgentName" label="变更后的承办单位"></el-table-column>
        <el-table-column prop="newOfficeName" label="变更后的考级点"></el-table-column>
        <el-table-column prop="auditStatus" label="审核状态">
          <template slot-scope="scope">
            {{$enums.auditStatus[scope.row.auditStatus]}}
          </template>
        </el-table-column>
        <el-table-column prop="applyReason" label="变更原因" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="addTime" label="申请时间">
          <template slot-scope="scope">
            {{$moment(scope.row.addTime).format('YYYY-MM-DD HH:mm')}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button v-if="scope.row.auditStatus == 1" size="mini" type="text" @click="pass(scope.row)">审核通过</el-button>
            <el-button v-if="scope.row.auditStatus == 1" size="mini" type="text" style="color: #E91212;" @click="handlerOpration(scope.row)">审核不通过</el-button>
            <el-button v-if="scope.row.auditStatus == 3" size="mini" type="text" @click="remarks(scope.row.unpassReason)">备注</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog
      width="500px"
      title="审核不通过原因"
      :center="true"
      :visible.sync="remarkDialog"
      append-to-body>
      <div style="text-align: left;padding-bottom: 50px;">
        <span>{{remarkRow}}</span>
      </div>
    </el-dialog>
    <el-dialog
      title="审核不通过"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <div>
        <div>
          <el-form :model="dialogForm" ref="dialogForm" :hide-required-asterisk="true">
            <div @keyup.enter.stop="handleAudit">
              <el-form-item prop="reason" :rules="[{required: true, message: '请输入审核不通过原因', trigger: 'blur'}, $validate.string(100)]">
                <el-input style="margin-right:10px;margin-bottom: 10px;" type="textarea" :rows="3" show-word-limit v-model="dialogForm.reason" maxlength="100" clearable
                          placeholder="请输入审核不通过原因……"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="text-right">
          <el-button size="medium" @click="handleClose">取消</el-button>
          <el-button size="medium" type="primary" @click="handleAudit" style="margin-right: 0px;">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  name: 'office-apply-record',
  components: {},
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      batchList: [],
      agentList: [],
      officeList: [],
      multipleSelection: [],
      taskInterval: 0,
      remarkRow: '',
      remarkDialog: false,
      dialogVisible: false,
      dialogForm: {}
    }
  },
  async created () {
    await this.getPermission()
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('请先添加考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    // await this.getOfficeList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
    clearInterval(this.taskInterval)
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.agentId = ''
        this.queryParam.officeId = ''
      }
      await this.getPage()
    },
    async getOfficeList (event) {
      this.officeList = await this.$HTTP.ApiOffice.getAgentList(this.queryParam)
      if (event) {
        this.queryParam.officeId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiChangeAgent.getPage(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async pass (item) {
      try {
        let confirm = await this.$confirm('确定审核通过？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          await this.$HTTP.ApiChangeAgent.auditChangeAgent({
            logId: item.logId,
            userId: item.userId,
            isPass: 1
          })
          this.$message.success('操作成功')
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    handlerOpration (item) {
      this.dialogVisible = true
      this.dialogForm = item
    },
    handleClose () {
      this.dialogVisible = false
      this.dialogForm = {}
    },
    handleAudit () {
      this.$refs['dialogForm'].validate(async (valid) => {
        if (valid) {
          try {
            await this.$HTTP.ApiChangeAgent.auditChangeAgent({
              unpassReason: this.dialogForm.reason,
              logId: this.dialogForm.logId,
              userId: this.dialogForm.userId,
              isPass: 0
            })
            this.$message.success('操作成功')
            this.handleClose()
            await this.getPage()
          } catch (error) {
            this.$message.error(error.message || '操作失败')
          }
        } else {
          return false
        }
      })
    },
    async remarks (row) {
      this.remarkDialog = true
      this.remarkRow = row
    },
    async exportExcel (row) {
      try {
        await this.$HTTP.ApiTimeAudit.exportExcel(this.queryParam.batchId)
        this.getTaskInfo('export_time_audit')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamResult.getTaskInfo(taskName)
          if (taskInfo) {
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '操作成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms)
    },
    getPermission () { // 模拟接口 获取 权限数据集合
      let perms = this.$store.state.buttonList
      // this.$store.dispatch("SET_PERMISSION", perms)
    }
  }
}
</script>
<style>
  .el-tooltip__popper.is-dark {
    max-width: 300px;
  }
</style>
